export const ResponseCodeEnum = {
  Ok: 0,
  SessionLost: 5,
  NeedToLogin: 12,
};
